import React, { useEffect, useRef, useState } from "react";

export default function Todo() {
  const [value, setValue] = useState("");
  const [items, setItems] = useState([]);
  const [visible, setVisible] = useState(false);
  const InputRef = useRef();
  const [message, setMessage] = useState(true);

  const handleOnsubmit = (e) => {
    e.preventDefault();
    setItems([...items, value]);
    InputRef.current.value = null;
  };

  const handleOnChange = (e) => {
    setValue(e.target.value);
  };

  const onClickButton = () => {
    alert("Your task is resgister");
  };

  const removeItem = (id) => {
    const itemDelete = (item) => {
      return item.id !== id;
    };
    setItems([itemDelete]);
  };

  useEffect(() => {
    setVisible(!visible);
    setMessage(!message); // eslint-disable-next-line
    // eslint-disable-next-line
  }, [value]);

  return (
    <div>
      <h1>TODO LISTE</h1>
      <form onSubmit={handleOnsubmit}>
        <input
          type="text"
          placeholder="Put your task"
          onChange={handleOnChange}
          ref={InputRef}
        />

        <button type="submit" style={{ color: "blue" }} onClick={onClickButton}>
          ADD
        </button>
      </form>
      {visible && (
        <p style={{ color: "red" }}>Don't forget to do your tasks today</p>
      )}
      <ul>
        {items.map((item, index) => {
          return (
            <li
              key={index}
              style={{ listStyle: "none", marginBottom: 10, color: "blue" }}
              onClick={removeItem}
            >
              {item}
            </li>
          );
        })}
      </ul>
      {message && (
        <p style={{ color: "green" }}>IF YOUR TASKS IS DONE DELETE THEM</p>
      )}
    </div>
  );
}
